import {RootState} from '../store';

export const searchSameValueSelector = (state: RootState) => state.search.searchSameValueCount;
